import TimeInputDemo from '../pages/demo/components/TimeInput';
import {Route, Routes} from 'react-router-dom';
import Demo from '../pages/demo/Demo';
import TextField from '../pages/demo/components/TextField';
import ModalDemo from '../pages/demo/components/ModalDemo';
import TooltipWrapperDemo from '../pages/demo/components/TooltioWrapperDemo';
import PaginationDemo from '../pages/demo/components/PaginationDemo';
import ToastDemo from '../pages/demo/components/ToastDemo';
import CollapsiblePanelDemo from '../pages/demo/components/CollapsiblePanelDemo';
import BannerDemo from '../pages/demo/components/BannerDemo';
import NavigationListDemo from '../pages/demo/components/NavigationListDemo';
import IconButton from '../pages/demo/components/IconButton';
import DrawerDemo from '../pages/demo/components/DrawerDemo';
import TooltipDemo from '../pages/demo/components/TooltipDemo';
import DatePicker from '../pages/demo/components/DatePicker';
import DataGridDemo from '../pages/demo/components/DataGridDemo';
import SelectDropdown from '../pages/demo/components/SelectDropdown';
import TransferListDemo from '../pages/demo/components/TransferListDemo';
import MenuDemo from '../pages/demo/components/MenuDemo';
import WidgetWrapperDemo from '../pages/demo/components/WidgetWrapperDemo';
import LineChart from '../pages/demo/components/LineChart';
import LoadingSpinner from '../pages/demo/components/LoadingSpinner';
import FilterChipDemo from '../pages/demo/components/FilterChipDemo';
import PieChart from '../pages/demo/components/PieChart';
import FunnelDemo from '../pages/demo/components/FunnelChartDemo';
import LinearProgressBar from '../pages/demo/components/LinearProgressBar';
import TreeViewDemo from '../pages/demo/components/TreeViewDemo';
import RadioDemo from '../pages/demo/components/RadioDemo';
import CheckboxDemo from '../pages/demo/components/CheckboxDemo';
import ToggleDemo from '../pages/demo/components/ToggleDemo';
import PaginationProDemo from '../pages/demo/components/PaginationProDemo';
import CodingFormEditorDemo from '../pages/demo/components/CodingFormEditorDemo';
import StepperDemo from '../pages/demo/components/WizardStepperDemo';
import DocumentTileDemo from '../pages/demo/components/DocumentTileDemo';
import AccordionExample from '../pages/demo/components/AccordionDemo';
import SelectSourceDemo from '../pages/demo/components/SelectSource';
import FloatingPanelDemo from '../pages/demo/components/FloatingPanelDemo';
import Thumbnail from '../pages/demo/components/Thumbnail';
import NumericInputDemo from '../pages/demo/components/NumericInputDemo';
import ArrSliderDemo from '../pages/demo/components/ArrSliderDemo';
import ArrAccordionWithCheckboxDemo from '../pages/demo/components/AccordionWithCheckboxDemo';
import BarChartSelectableDemo from '../pages/demo/components/BarChartSelectable';
import TextAreaDemo from '../pages/demo/components/TextArea';
import ActionButtonDemo from '../pages/demo/components/ActionButtonDemo';
import ArrCheckboxListDemo from '../pages/demo/components/CheckboxListDemo';
import FilterAccordionDemo from '../pages/demo/components/FilterAccordionDemo';
import BarChartDemo from '../pages/demo/components/BarChartDemo';
import SplitPanelDemo from '../pages/demo/components/SplitPanelDemo';
import DateTimePicker from '../pages/demo/components/DateTimePicker';
import WaitToCompleteModal from '../pages/demo/components/WaitToCompleteModal';
import SelectionChip from '../pages/demo/components/SelectionChip';
import PopoutPanelDemo from '../pages/demo/components/PopoutPanelDemo';
import TreeItemSelectorDemo from '../pages/demo/components/TreeItemSelectorDemo';
import SearchProgressDialog from '../pages/demo/components/SearchProgressDialog';
import ResultTileDemo from '../pages/demo/components/ResultTileDemo';
import TileSelectionDemo from '../pages/demo/components/TileSelectionDemo';
import SelectableColumnChart from '../pages/demo/components/SelectableColumnChart';
import RichTextEditorDemo from '../pages/demo/components/RichTextEditorDemo';
import AiThinkingLoaderDemo from '../pages/demo/components/AIThinkingLoaderDemo';
import MetricsDemo from '../pages/demo/components/MetricsDemo';
import AIReviewJobDetailsDemo from '../pages/demo/components/AIReviewJobDetailsDemo';

const DemoRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Demo />} />
      <Route path="components/numeric-input" element={<NumericInputDemo />} />
      <Route path="components/arr-slider" element={<ArrSliderDemo />} />
      <Route path="components/banner" element={<BannerDemo />} />
      <Route
        path="components/navigation-list"
        element={<NavigationListDemo />}
      />
      <Route path="components/action-button" element={<ActionButtonDemo />} />
      <Route
        path="components/collapsiblePanel"
        element={<CollapsiblePanelDemo />}
      />
      <Route
        path="components/collapsiblePanel"
        element={<CollapsiblePanelDemo />}
      />
      <Route path="components/document-tile" element={<DocumentTileDemo />} />
      <Route path="components/accordion" element={<AccordionExample />} />
      <Route
        path="components/accordion-with-checkbox"
        element={<ArrAccordionWithCheckboxDemo />}
      />
      <Route
        path="components/checkbox-list"
        element={<ArrCheckboxListDemo />}
      />
      <Route path="components/floating-panel" element={<FloatingPanelDemo />} />
      <Route path="components/banner" element={<BannerDemo />} />
      <Route path="components/drawer" element={<DrawerDemo />} />
      <Route path="components/modal" element={<ModalDemo />} />
      <Route path="components/pagination" element={<PaginationDemo />} />
      <Route path="components/textfield" element={<TextField />} />
      <Route path="components/toast" element={<ToastDemo />} />
      <Route
        path="components/tooltip-wrapper"
        element={<TooltipWrapperDemo />}
      />
      <Route path="components/iconbutton" element={<IconButton />} />
      <Route path="components/tooltip" element={<TooltipDemo />} />
      <Route path="components/datepicker" element={<DatePicker />} />
      <Route path="components/date-time-picker" element={<DateTimePicker />} />
      <Route path="components/icon-button" element={<IconButton />} />
      <Route path="components/data-grid" element={<DataGridDemo />} />
      <Route path="components/select-dropdown" element={<SelectDropdown />} />
      <Route path="components/selection-chip" element={<SelectionChip />} />
      <Route path="components/transfer-list" element={<TransferListDemo />} />
      <Route path="components/menu" element={<MenuDemo />} />
      <Route path="components/widget-wrapper" element={<WidgetWrapperDemo />} />
      <Route path="components/text-area" element={<TextAreaDemo />} />
      <Route path="components/linechart" element={<LineChart />} />
      <Route path="components/loading-spinner" element={<LoadingSpinner />} />
      <Route path="components/filter-chip" element={<FilterChipDemo />} />
      <Route path="components/piechart" element={<PieChart />} />
      <Route path="components/funnel-chart" element={<FunnelDemo />} />
      <Route
        path="components/linear-progressbar"
        element={<LinearProgressBar />}
      />
      <Route path="components/tree-view" element={<TreeViewDemo />} />
      <Route path="components/radio" element={<RadioDemo />} />
      <Route path="components/checkbox" element={<CheckboxDemo />} />
      <Route path="components/toggle" element={<ToggleDemo />} />
      <Route path="components/pagination-pro" element={<PaginationProDemo />} />
      <Route
        path="components/codingform-editor"
        element={<CodingFormEditorDemo />}
      />
      <Route path="components/WizardStepper" element={<StepperDemo />} />
      <Route path="components/select-source" element={<SelectSourceDemo />} />
      <Route path="components/thumbnail" element={<Thumbnail />} />
      <Route
        path="components/bar-chart-selectable"
        element={<BarChartSelectableDemo />}
      />
      <Route path="components/time-input" element={<TimeInputDemo />} />
      <Route
        path="components/filterAccordion"
        element={<FilterAccordionDemo />}
      />
      <Route path="components/bar-chart" element={<BarChartDemo />} />
      <Route path="components/split-panel" element={<SplitPanelDemo />} />
      <Route
        path="components/selectable-column-chart"
        element={<SelectableColumnChart />}
      />

      <Route
        path="components/search-progress-dialog"
        element={<SearchProgressDialog />}
      />

      <Route
        path="components/wait-to-complete-modal"
        element={<WaitToCompleteModal />}
      />
      <Route path="components/popout-panel" element={<PopoutPanelDemo />} />
      <Route
        path="components/tree-item-selector"
        element={<TreeItemSelectorDemo />}
      />
      <Route path="components/result-tile" element={<ResultTileDemo />} />
      <Route path="components/tile-selection" element={<TileSelectionDemo />} />
      <Route
        path="components/rich-text-editor"
        element={<RichTextEditorDemo />}
      />
      <Route
        path="components/AIThinkingLoader"
        element={<AiThinkingLoaderDemo />}
      />
      <Route path="components/Metrics" element={<MetricsDemo />} />
      <Route
        path="components/AIReviewJobDetails"
        element={<AIReviewJobDetailsDemo />}
      />
    </Routes>
  );
};

export default DemoRoutes;
